import vector2 from "../assets/vector2.svg";

const VerticalDividerVector = () => {
  return (
    <div className="flex justify-center items-center py-[12px]">
      <img
        src={vector2}
        alt="vector"
        className="w-2 h-[38px] stroke-[1px] stroke-[rgba(226,_232,_240,_0.00)]"
      />
    </div>
  );
};

export default VerticalDividerVector;
